/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResolveDefRecommendationsRequest {
    getFixupPrototypeFunction() { return ResolveDefRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ResolveDefRecommendationsRequest>): ResolveDefRecommendationsRequest {
        let obj = Object.assign(new ResolveDefRecommendationsRequest(), model);
        ResolveDefRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResolveDefRecommendationsRequest>): ResolveDefRecommendationsRequest {
        if (!model) return null;
        return ResolveDefRecommendationsRequest.newInstance(<ResolveDefRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResolveDefRecommendationsRequest) {
        if (!obj) return;

        models.ResolveDefRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResolveDefRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ResolveDefRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action Name to resolve the recommendation
     */
    action_name: string;

    /**
     * Specify the Resource IDs. It will be fetched from list recommendation api
     */
    resources: Array<string>;

}
